
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3333 2C6.33333 2 2 3.08333 2 5.33333C2 7.58333 6.33333 8.66667 10.3333 8.66667C14.3333 8.66667 18.6667 7.58333 18.6667 5.33333C18.6667 3.08333 14.3333 2 10.3333 2ZM2 8.33331C3.91667 9.74998 7.16667 10.3333 10.3333 10.3333C13.5 10.3333 16.75 9.74998 18.6667 8.33331V12C18.6667 12.3637 18.5534 12.6969 18.3467 13H15V14H13V15.1717C12.1288 15.2797 11.2228 15.3333 10.3333 15.3333C6.33333 15.3333 2 14.25 2 12V8.33331ZM13 16.8553C12.1257 16.9536 11.2262 17 10.3333 17C7.16667 17 3.91667 16.4167 2 15V18.6667C2 20.9167 6.33333 22 10.3333 22C11.2228 22 12.1288 21.9464 13 21.8384V16.8553Z"></path><path d="M15 16.6666V21C15 21.2652 15.1054 21.5195 15.2929 21.7071C15.4804 21.8946 15.7348 22 16 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5195 21 21.2652 21 21V16.6666H15ZM17 20.3333H16.3333V18H17V20.3333ZM18.3333 20.3333H17.6667V18H18.3333V20.3333ZM19.6667 20.3333H19V18H19.6667V20.3333Z"></path><path d="M21.6667 15.3333H19.6667V14.3333C19.6667 14.2449 19.6315 14.1601 19.569 14.0976C19.5065 14.0351 19.4217 14 19.3333 14H16.6667C16.5783 14 16.4935 14.0351 16.431 14.0976C16.3685 14.1601 16.3333 14.2449 16.3333 14.3333V15.3333H14.3333C14.2449 15.3333 14.1601 15.3685 14.0976 15.431C14.0351 15.4935 14 15.5783 14 15.6667C14 15.7551 14.0351 15.8399 14.0976 15.9024C14.1601 15.9649 14.2449 16 14.3333 16H21.6667C21.7551 16 21.8399 15.9649 21.9024 15.9024C21.9649 15.8399 22 15.7551 22 15.6667C22 15.5783 21.9649 15.4935 21.9024 15.431C21.8399 15.3685 21.7551 15.3333 21.6667 15.3333ZM17 14.6667H19V15.3333H17V14.6667Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowdeldataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
